import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsDataManagerObjectClassSettingsRoute: InvariantJiraRoute = {
	name: 'assets-data-manager-object-class-settings',
	path: '/jira/assets/data-manager/object-class/settings/:settingType(mapping-matrix|cleansing-statistics|data-dictionaries|default-attribute-mapping)?',
	exact: true,
};
